import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import { getTrackerCheckboardFlagPath } from "../../../Common/utils/cloudinary";
import Media from "../../media";

const TrackerCheckboardFlag = () => {
  const { configData, cloudinaryBase, envVersion, currentSeasonYear } =
    useCloudinaryData();

  const flagImagePath = getTrackerCheckboardFlagPath(
    configData,
    cloudinaryBase,
    envVersion,
    currentSeasonYear
  );
  return <Media imgSrc={flagImagePath} imgAlt="Tracker Checkboard Flag" />;
};

export default TrackerCheckboardFlag;
